import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $libraryPurchasedTvChannelsTranslations = combine(
  i18n.$t,
  ({ t }) => ({
    liveChannels: t('purchased_live_channels'),
  })
)
